import { useThemeStore } from "@stores/theme.store";
import { useEffect, useState } from "react";
import { Button, Form, Input, message } from "antd";
import { BiLogoWhatsapp } from "react-icons/bi";
import { LuHash, LuUser } from "react-icons/lu";
import { useMutation, useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { ProfileAvatarHeader } from "@components/general/profile_avatar_header";
import { Spiner } from "@components/loaders/spiner";
import { NoticeType } from "antd/es/message/interface";

export const SettingUpdateAccountPage = () => {
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";
  const gender = dataNis?.data?.gender ?? "";

  const { data, isPending, refetch } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIOGRAPHY, nis],
    queryFn: () => SchoolService.studentBiography(nis),
  });

  const { mutate: onUpdateBio, isPending: isPendingUpdateBio } = useMutation({
    mutationFn: SchoolService.updateStudentBiography,
    onSuccess: (response) => {
      setShowMessage(true);
      setMessageType("success");
      setShowMessageText(response.message);

      refetch();
    },
    onError: (error: any) => {
      setShowMessage(true);
      setMessageType("error");
      setShowMessageText(error.message ?? "Internal Error");
    },
  });

  useEffect(() => {
    setAppBar({ title: "Edit Profil", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      title: "Edit Profil",
      filter: false,
      image: false,
    });
  }, [setHeader, setAppBar]);

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText]);

  return (
    <>
      {contextHolder}
      <div className="tw-px-4 tw-pt-2 tw-pb-0">
        <Form
          className=""
          autoComplete="off"
          initialValues={{
            nis: nis,
            namasiswa: data?.data?.namasiswa ?? "---",
            telephon: data?.data?.telephon ?? "---",
            kelas: data?.data?.kelas ?? "---",
          }}
          onFinish={(data) => onUpdateBio(data)}
        >
          <div className="tw-mb-4 tw-mt-12 tw-pt-14 tw-relative tw-text-center card-body">
            <ProfileAvatarHeader
              foto={data?.data?.foto}
              namasiswa={data?.data?.namasiswa}
              kelas={data?.data?.kelas}
              marhalah={data?.data?.marhalah}
              gender={gender}
              isPending={isPending}
            />

            <div className="tw-my-4 divider"></div>

            <div className="tw-mb-6 tw-text-accent-primary">
              {isPending ? (
                <div className="tw-p-8 tw-text-center">
                  <Spiner />
                </div>
              ) : (
                <>
                  <Form.Item label="NIS" name="nis" className="tw-mb-4">
                    <Input
                      suffix={
                        <LuHash
                          size={20}
                          className="tw-text-text-primary"
                        />
                      }
                      className="tw-border-background tw-shadow-none hover:tw-border-primary focus:tw-shadow-none tw-text-base"
                      placeholder="NIS"
                      disabled={true}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Nama Lengkap"
                    name="namasiswa"
                    className="tw-mb-4"
                  >
                    <Input
                      suffix={
                        <LuUser size={20} className="tw-text-text-primary" />
                      }
                      className="tw-border-background tw-shadow-none hover:tw-border-primary focus:tw-shadow-none tw-text-base"
                      placeholder="Nama Lengkap"
                      disabled={true}
                    />
                  </Form.Item>

                  <Form.Item
                    label="No. Telepon (WhatsApp)"
                    name="telephon"
                    className="tw-mb-4"
                  >
                    <Input
                      suffix={
                        <BiLogoWhatsapp
                          size={20}
                          className="tw-text-[#91C60B]"
                        />
                      }
                      className="tw-border-background tw-shadow-none hover:tw-border-primary focus:tw-shadow-none tw-text-base"
                      placeholder="-----"
                    />
                  </Form.Item>
                </>
              )}
            </div>
          </div>

          <Button
            type="primary"
            htmlType="submit"
            loading={isPendingUpdateBio}
            className="tw-h-10 tw-w-full tw-text-base tw-rounded-xl bg-gradient tw-shadow-md focus:tw-shadow-none hover:tw-bg-white hover:tw-text-accent-primary hover:tw-border-primary"
          >
            Simpan
          </Button>
        </Form>
      </div>
    </>
  );
};
